
export default class Marker{
    constructor(params){
        this.floorId = params.point.locationId;
        this.icon = params.point.category.name;
        this.x = params.x;
        this.y = params.y;
    }
}
